import { render, staticRenderFns } from "./DuplicateWarningModal.vue?vue&type=template&id=6c7bbb6d&scoped=true"
import script from "./DuplicateWarningModal.vue?vue&type=script&lang=js"
export * from "./DuplicateWarningModal.vue?vue&type=script&lang=js"
import style0 from "./DuplicateWarningModal.vue?vue&type=style&index=0&id=6c7bbb6d&prod&scoped=true&lang=css"
import style1 from "./DuplicateWarningModal.vue?vue&type=style&index=1&id=6c7bbb6d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7bbb6d",
  null
  
)

export default component.exports